import { ModalContextProvider } from 'utils/contexts/modal';
import { JobManagerIndexPage } from './JobManagerIndexPage';
import 'modules/jobManager/ducks/sagas';

export const JobManagerIndexContext = () => {
  return (
    <ModalContextProvider>
      <JobManagerIndexPage />
    </ModalContextProvider>
  );
};
